<div 
  class="incoming-call-notification" 
  *ngIf="currentNotification && currentNotification.isVisible"
  [@slideDown]="currentNotification.isVisible ? 'visible' : 'hidden'"
>
  <div class="notification-content">
    <div class="call-info">
      <ion-icon name="videocam" class="call-icon" *ngIf="currentNotification.hasVideo"></ion-icon>
      <ion-icon name="call" class="call-icon" *ngIf="!currentNotification.hasVideo"></ion-icon>
      <div class="call-details">
        <div class="caller-name">{{ getCallerDisplayName() }}</div>
      </div>
    </div>
    
    <div class="call-actions">
      <button 
        class="action-button answer-button" 
        (click)="onAnswer()"
        aria-label="Answer call"
      >
        <ion-icon name="call" class="answer-icon"></ion-icon>
      </button>
    </div>
    
    <button 
      class="dismiss-button" 
      (click)="onDismiss()"
      aria-label="Dismiss notification"
    >
      <ion-icon name="close"></ion-icon>
    </button>
  </div>
</div> 